import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n          ~ ", " { border-color: ", " !important; }\n          ~ ", " { background-color: ", " !important; }\n          ~ ", " > svg { fill: ", " !important; }\n          &:checked {\n            ~ ", " { border-color: ", " !important; }\n            ~ ", " { background-color: ", " !important; }\n            ~ ", " > svg { fill: ", " !important; }\n          }\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n          ~ ", " { border-color: ", "; }\n          ~ ", " { background-color: ", "; }\n          ~ ", " > svg { fill: ", "; }\n          &:checked {\n            ~ ", " { border-color: ", "; }\n            ~ ", " { background-color: ", "; }\n            ~ ", " > svg { fill: ", "; }\n          }\n        "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n          ~ ", " { border-color: ", "; }\n          ~ ", " { background-color: ", "; }\n          ~ ", " > svg { fill: ", "; }\n          &:checked {\n            ~ ", " { border-color: ", "; }\n            ~ ", " { background-color: ", "; }\n            ~ ", " > svg { fill: ", "; }\n          }\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n            &:hover,\n            &:active {\n              ~ ", " { border-color: ", "; }\n              ~ ", " { background-color: ", "; }\n              ~ ", " > svg { fill: ", "; }\n            }\n          "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n            &:hover,\n            &:active {\n              ~ ", " { border-color: ", "; }\n              ~ ", " { background-color: ", "; }\n              ~ ", " > svg { fill: ", "; }\n            }\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  pointer-events: none;\n\n  /* hover state */\n  ", "\n\n  /* default state */\n  ~ ", " {\n    border-color: ", ";\n  }\n  ~ ", " {\n    background-color: ", ";\n  }\n  ~ ", " > svg {\n    fill: ", ";\n  }\n  &:checked {\n    ~ ", " {\n      border-color: ", ";\n    }\n    ~ ", " {\n      background-color: ", ";\n    }\n    ~ ", " > svg {\n      fill: ", ";\n    }\n  }\n\n  /* error state */\n  ", "\n\n  /* alarm state */\n  ", "\n  \n  /* disabled state */\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  pointer-events: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n          &:after {\n            display: block;\n            border: 1px solid transparent;\n            transform: translate(-1px, -1px);\n            border-radius: 4px;\n            ", "\n            ", "\n            ", "\n            ", "\n            content: '';\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  pointer-events: none;\n  display: flex;\n  position: relative;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  background-color: transparent;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  transition: border-color 0.2s ease-in-out, background-color 0.1s ease-out;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: content-box;\n  flex-shrink: 0;\n  cursor: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, ELEMENT_GRAY, LINE_GRAY, RIOJA_RED, RIOJA_RED_FOCUSED, SENSATION_WHITE } from '../../colors';
import CheckmarkIcon from '@tourlane/iconography/Glyphs/Other/Checkmark';
import { Icon } from '../../SvgIcon';
import { CHECKBOX_SIZE } from './constants';
import { borderShadowMixin } from '../../mixins/border';
import { useDeviceType } from '../../hooks';
import { isDefined } from '../../helpers/defined';
import { setNoFocus } from '../../helpers/events-focus';
import { fullSizeAbsoluteStyle } from '../../tokens/full-size';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { pointerEventsNoneStyle } from '../../tokens/pointer-events';
import { baseHighlightStyle } from '../../tokens/highlight';
import { size } from '../../style/size';
import { height } from '../../style/height';
import { width } from '../../style/width';
export var CheckboxWrapper = styled.label(_templateObject(), function (_ref) {
  var $disabled = _ref.$disabled;
  return !$disabled ? 'pointer;' : 'not-allowed';
}, baseHighlightStyle, function (_ref2) {
  var value = _ref2.$size;
  return isDefined(value) ? size(value) : '';
}, function (_ref3) {
  var value = _ref3.$width;
  return isDefined(value) ? width(value) : '';
}, function (_ref4) {
  var value = _ref4.$height;
  return isDefined(value) ? height(value) : '';
});
var StyledCheckbox = styled.span(_templateObject2(), size(CHECKBOX_SIZE), function (_ref5) {
  var $borderColor = _ref5.$borderColor;
  return $borderColor ? css(_templateObject3(), fullSizeAbsoluteStyle, borderShadowMixin, userSelectNoneStyle, pointerEventsNoneStyle) : '';
});
var StyledIcon = styled(Icon)(_templateObject4());
var StyledInput = styled.input(_templateObject5(), function (_ref6) {
  var $hasTouch = _ref6.$hasTouch,
      $isAlarm = _ref6.$isAlarm,
      $hasError = _ref6.$hasError;
  return (
    /* prettier-ignore */
    !$hasTouch ? $isAlarm || $hasError ? css(_templateObject6(), StyledCheckbox, RIOJA_RED_FOCUSED, StyledCheckbox, SENSATION_WHITE, StyledCheckbox, RIOJA_RED_FOCUSED) : css(_templateObject7(), StyledCheckbox, ELEMENT_GRAY, StyledCheckbox, SENSATION_WHITE, StyledCheckbox, ADVENTURE_GREEN_FOCUSED) : ''
  );
}, StyledCheckbox, ELEMENT_GRAY, StyledCheckbox, SENSATION_WHITE, StyledCheckbox, LINE_GRAY, StyledCheckbox, ADVENTURE_GREEN, StyledCheckbox, ADVENTURE_GREEN, StyledCheckbox, SENSATION_WHITE, function (_ref7) {
  var $hasError = _ref7.$hasError;
  return (
    /* prettier-ignore */
    $hasError ? css(_templateObject8(), StyledCheckbox, RIOJA_RED, StyledCheckbox, SENSATION_WHITE, StyledCheckbox, LINE_GRAY, StyledCheckbox, ADVENTURE_GREEN, StyledCheckbox, ADVENTURE_GREEN, StyledCheckbox, SENSATION_WHITE) : ''
  );
}, function (_ref8) {
  var $isAlarm = _ref8.$isAlarm;
  return (
    /* prettier-ignore */
    $isAlarm ? css(_templateObject9(), StyledCheckbox, RIOJA_RED, StyledCheckbox, SENSATION_WHITE, StyledCheckbox, LINE_GRAY, StyledCheckbox, RIOJA_RED, StyledCheckbox, RIOJA_RED, StyledCheckbox, SENSATION_WHITE) : ''
  );
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return (
    /* prettier-ignore */
    disabled ? css(_templateObject10(), StyledCheckbox, LINE_GRAY, StyledCheckbox, SENSATION_WHITE, StyledCheckbox, LINE_GRAY, StyledCheckbox, ELEMENT_GRAY, StyledCheckbox, ELEMENT_GRAY, StyledCheckbox, SENSATION_WHITE) : ''
  );
});

var _ref11 = /*#__PURE__*/React.createElement(StyledIcon, {
  as: CheckmarkIcon,
  size: CHECKBOX_SIZE
});

var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref10, ref) {
  var _ref10$hasError = _ref10.hasError,
      hasError = _ref10$hasError === void 0 ? false : _ref10$hasError,
      _ref10$isAlarm = _ref10.isAlarm,
      isAlarm = _ref10$isAlarm === void 0 ? false : _ref10$isAlarm,
      size = _ref10.size,
      width = _ref10.width,
      height = _ref10.height,
      className = _ref10.className,
      onClick = _ref10.onClick,
      disabled = _ref10.disabled,
      _ref10$noFocus = _ref10.noFocus,
      noFocus = _ref10$noFocus === void 0 ? false : _ref10$noFocus,
      borderColor = _ref10.borderColor,
      props = _objectWithoutPropertiesLoose(_ref10, ["hasError", "isAlarm", "size", "width", "height", "className", "onClick", "disabled", "noFocus", "borderColor"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  return /*#__PURE__*/React.createElement(CheckboxWrapper, {
    $size: size,
    $width: width,
    $height: height,
    $disabled: disabled,
    className: className,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({
    ref: ref,
    type: "checkbox",
    disabled: disabled,
    $isAlarm: isAlarm,
    $hasError: hasError,
    $hasTouch: hasTouchScreen
  }, props, setNoFocus(props, noFocus))), /*#__PURE__*/React.createElement(StyledCheckbox, {
    $disabled: disabled,
    $hasError: hasError,
    $isAlarm: isAlarm,
    $borderColor: borderColor
  }, _ref11));
});
export default Checkbox;